import { usePopup } from '../context/PopupContext';

export default function CTABanner({ showChat = false, label, heading, buttonText, description }) {
  const { openPopup } = usePopup();

  return (
    <section data-testid="cta-banner" className="relative overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="/assets/img/bg-cta.webp"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-[#0A1128]/85" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#D4AF37]/8 via-transparent to-[#D4AF37]/8" />
      </div>

      {/* Gold accent lines */}
      <div className="absolute top-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-[#D4AF37]/40 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-[#D4AF37]/40 to-transparent" />

      <div className="container mx-auto px-6 md:px-12 text-center relative z-10 py-20 md:py-28">
        <p className="uppercase text-xs tracking-[0.2em] font-bold text-[#D4AF37] mb-5 font-['Outfit']">{label || "Take The Next Step"}</p>
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white font-['Outfit'] tracking-tight mb-6">
          {heading || "Don't Risk Losing Your Brand."}
        </h2>
        <p className="text-[#A0AABF] text-base md:text-lg max-w-2xl mx-auto mb-10">
          {description || "Start your trademark registration today and prevent unauthorized use."}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            data-testid="cta-register-btn"
            onClick={() => openPopup()}
            className="bg-[#D4AF37] text-[#0A1128] font-bold py-4 px-10 rounded-sm text-sm transition-all duration-300 hover:bg-[#F3E5AB] hover:-translate-y-1 shadow-[0_4px_14px_0_rgba(212,175,55,0.39)] font-['Outfit'] tracking-wider uppercase animate-pulse-gold"
          >
            {buttonText || "Start My Trademark Protection"}
          </button>
          {showChat && (
            <button
              data-testid="cta-chat-btn"
              className="js-chat border border-[#D4AF37]/50 text-[#D4AF37] font-bold py-4 px-10 rounded-sm text-sm transition-all duration-300 hover:bg-[#D4AF37]/10 hover:border-[#D4AF37] hover:-translate-y-1 font-['Outfit'] tracking-wider uppercase"
            >
              Chat Now
            </button>
          )}
        </div>
      </div>
    </section>
  );
}
